import { cn } from '~/utils/cn';
import { formatCentsToBRLCompact } from '~/utils/formatFinance';
import { relativeDueLabel } from '~/utils/contractLabels';
import type { ContractInstallment } from '~/store/contracts/interfaces';

import { Icon } from '../../atoms/Icon/view';
import { Text } from '../../atoms/Text/view';

interface PropsScheduleRow {
  installment: ContractInstallment;
  contractLabel?: string;
  onClick?: () => void;
  className?: string;
}

const STATUS_STYLE: Record<ContractInstallment['status'], { dot: string; text: string }> = {
  paid: { dot: 'bg-success-04', text: 'color-success-06' },
  next: { dot: 'bg-primary-01', text: 'color-primary-01' },
  future: { dot: 'bg-intense-04', text: 'color-intense-06' },
  overdue: { dot: 'bg-warning-04', text: 'color-warning-06' },
};

const MONTHS = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
const fmtDay = (iso?: string) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return `${String(d.getUTCDate()).padStart(2, '0')} ${MONTHS[d.getUTCMonth()]}`;
};

export default function ScheduleRow({ installment, contractLabel, onClick, className }: PropsScheduleRow) {
  const style = STATUS_STYLE[installment.status];

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex w-full items-center gap-smaller rounded-small bg-intense-01 border border-intense-03 px-small py-smaller hover:bg-intense-02',
        className,
      )}
    >
      <div className={cn('h-[10px] w-[10px] rounded-full', style.dot)} />
      <div className="flex-1 text-left">
        <Text className="text-bodyLG color-complement-01">
          Parcela {installment.index} · {fmtDay(installment.dueDate)}
        </Text>
        <Text className="text-captionMD color-intense-06">
          {contractLabel ? `${contractLabel} · ` : ''}
          {relativeDueLabel(installment.dueDate)}
        </Text>
      </div>
      <div className="text-right">
        <Text className={cn('text-bodyLG', style.text)}>
          {formatCentsToBRLCompact(installment.amount)}
        </Text>
      </div>
      <Icon name="icon-chevron-right" size={16} color="#606060" rounded={false} />
    </button>
  );
}
